import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates, TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { useApplicationContext } from '../../../../../utils/applicationContext';
import { useAdfoxContext } from '../../../external/context/AdfoxContext';
import { TgbNativedescGeneralContainer } from '../TgbNativedescGeneral';

type TBannerContext = TTgbNativedescGeneralContext;
type TBannerContextTypes = TBannerContext['type'];

const OWN_TYPES: Array<TBannerContextTypes> = ['tgb_nativedesc_general'];

export const OwnTemplates: React.FC<React.PropsWithChildren<TAdFoxBannerTemplate>> = props => {
  const { bundleName, bundleParams } = props;

  const { logger } = useApplicationContext();
  const { bannerPlace } = useAdfoxContext();

  if (bundleName === 'banner.transfer' && bundleParams?.htmlBase64) {
    try {
      const decodedParams = Base64.decode(bundleParams.htmlBase64);
      const parsedDecodedParams = JSON.parse(decodedParams);

      if (isParsedParamsValid(parsedDecodedParams) && OWN_TYPES.includes(parsedDecodedParams.type)) {
        switch (parsedDecodedParams.type) {
          case 'tgb_nativedesc_general':
            return (
              <TgbNativedescGeneralContainer
                behavior={bannerPlace === 'bottom' ? 'wide' : 'narrow'}
                context={parsedDecodedParams as TTgbNativedescGeneralContext}
              />
            );
        }
      }
    } catch (e) {
      logger.error(e, {
        message: '[AdFox] [Carousel] Failed to decode/parse bundleParams',
        bannerId: bundleParams.bannerId,
      });

      return null;
    }
  }

  return <AdFoxTemplates deviceType="desktop" {...props} />;
};

function isParsedParamsValid(params: object): params is TBannerContext {
  return 'type' in params;
}
